<template>


  <footer class="bg-white text-black relative">
    <!-- Legal Disclaimer Section - Only visible on Japan page -->
    <div v-if="showLegalDisclaimer" class="bg-gray-100 py-8 border-b border-gray-200">
      <div class="container mx-auto px-4 text-center">
        <p class="text-gray-800 text-sm font-medium mb-4">
          20歳未満の者の飲酒は法律で禁止されています。<br>
          20歳未満の者に対しては酒類を販売しません。
        </p>
        <router-link to="/legal-disclosure" class="text-xs text-gray-600 hover:text-gray-800 underline focus:outline-none">
          特定商取引法等に基づく表記
        </router-link>
      </div>
    </div>

    <div class="container mx-auto px-4 sm:px-12">
      <div class="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4 items-start py-12">
        <!-- Left section - Badge -->
        <div class="flex justify-center lg:justify-start col-span-2 lg:col-span-1">
          <img 
            src="/image/83IslandsBadge.svg" 
            alt="83 Islands Badge" 
            class="w-48 lg:w-72 h-48 lg:h-72 [&>g]:fill-white" 
          />
        </div>

        <!-- Second section - Contact Info -->
        <div class="flex flex-col space-y-2 font-maax text-center lg:text-left">
          <h3 class="font-bold mb-4">Our Address</h3>
          <div class="text-sm space-y-1">
            <p class="font-bold">83 Islands Distillery</p>
            <p>1276 Stella Mare,</p>
            <p>Port Vila, PO1276</p>
            <p>Vanuatu</p>
            <a href="tel:+6787550083" class="hover:text-gray-600 mt-4 block">+678 755 0083</a>
          </div>
        </div>

        <!-- Third section - First menu column -->
        <div class="flex flex-col space-y-2 font-maax text-center lg:text-left">
          <div class="flex flex-col space-y-1">
            <router-link to="/discover" class="hover:text-gray-600">Discover</router-link>
            <div class="ml-4 mt-1 flex flex-col space-y-1 border-l-2 border-gray-300 pl-3">
              <router-link to="/terroir" class="text-sm text-gray-700 hover:text-gray-900">Vanuatu Terroir</router-link>
              <router-link to="/restless-earth" class="text-sm text-gray-700 hover:text-gray-900">Our Restless Earth</router-link>
              <router-link to="/entropy-index" class="text-sm text-gray-700 hover:text-gray-900">Entropy Index</router-link>
            </div>
          </div>
          <div class="flex flex-col space-y-1">
            <router-link to="/spirits" class="hover:text-gray-600">The Spirits</router-link>
            <div class="ml-4 mt-1 flex flex-col space-y-1 border-l-2 border-gray-300 pl-3">
              <router-link to="/collections" class="text-sm text-gray-700 hover:text-gray-900">Collections</router-link>
              <router-link to="/rackhouse" class="text-sm text-gray-700 hover:text-gray-900">The Rackhouse</router-link>
              <router-link to="/batch" class="text-sm text-gray-700 hover:text-gray-900">Batch Information</router-link>
            </div>
          </div>
          <router-link to="/team" class="hover:text-gray-600">The Team</router-link>
          <router-link to="/tours" class="hover:text-gray-600">Tours & Events</router-link>
        </div>

        <!-- Fourth section - Second menu column -->
        <div class="flex flex-col space-y-2 font-maax text-center lg:text-left">
          <router-link to="/buy" class="hover:text-gray-600">Where to Buy</router-link>
          <router-link to="/contact" class="hover:text-gray-600">Contact Us</router-link>
          <router-link to="/in-the-news" class="hover:text-gray-600">In the News</router-link>
          <router-link to="/jobs" class="hover:text-gray-600">Jobs</router-link>
          <router-link to="/cookie-policy" class="hover:text-gray-600">Cookie Policy</router-link>
          <router-link to="/terms-and-conditions" class="hover:text-gray-600">Terms & Conditions</router-link>
          <router-link to="/legal-disclosure" class="hover:text-gray-600">Legal Disclosure (Japan)</router-link>
        </div>
      </div>

      <!-- Social Media Links & Copyright -->
      <div class="border-t border-gray-200 py-8">
        <div class="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div class="text-sm">© 2024 83 Islands Distillery</div>
          <div class="flex space-x-6">
            <a href="https://www.facebook.com/83IslandsDistillery" target="_blank" rel="noopener noreferrer" class="text-gray-600 hover:text-gray-900">
              <span class="sr-only">Facebook</span>
              <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24"><path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/></svg>
            </a>
            <a href="https://x.com/83islands" target="_blank" rel="noopener noreferrer" class="text-gray-600 hover:text-gray-900">
              <span class="sr-only">X</span>
              <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href="https://www.instagram.com/83islands/" target="_blank" rel="noopener noreferrer" class="text-gray-600 hover:text-gray-900">
              <span class="sr-only">Instagram</span>
              <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.897 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.897-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/></svg>
            </a>
            <a href="https://www.youtube.com/@83islands" target="_blank" rel="noopener noreferrer" class="text-gray-600 hover:text-gray-900">
              <span class="sr-only">YouTube</span>
              <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
            </a>
            <a href="https://www.linkedin.com/company/the-distillery-company-limited/" target="_blank" rel="noopener noreferrer" class="text-gray-600 hover:text-gray-900">
              <span class="sr-only">LinkedIn</span>
              <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'

// We can import the same navigation links if needed
const footerLinks = [
  { text: 'Discover', to: '/discover' },
  { text: 'The Spirits', to: '/spirits' },
  { text: 'Tours & Events', to: '/tours' },
  { text: 'News', to: '/news' },
  { text: 'Community', to: '/community' },
  { text: 'Where to Buy', to: '/buy' },
  { text: 'Contact Us', to: '/contact' }
]

const route = useRoute()

// Show legal disclaimer only on Japan page
const showLegalDisclaimer = computed(() => {
  return route.name === 'Japan'
})


</script>